var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Util = require("../util.js");

var DeprecationMixin = Util.DeprecationMixin;

var GraphSettings = require("../components/graph-settings.jsx");
var InfoTip = require("../components/info-tip.jsx");

var InteractiveGraph = require("./interactive-graph.jsx").widget;

var _require = require("../styles/constants.js"),
    interactiveSizes = _require.interactiveSizes;

var _require2 = require("../util/sizing-utils.js"),
    containerSizeClass = _require2.containerSizeClass,
    getInteractiveBoxFromSizeClass = _require2.getInteractiveBoxFromSizeClass;

var defaultBackgroundImage = {
    url: null
};

var deprecatedProps = {
    showGraph: function showGraph(props) {
        return { markings: props.showGraph ? "graph" : "none" };
    }
};

var InteractiveGraphEditor = React.createClass({
    displayName: "InteractiveGraphEditor",

    className: "perseus-widget-interactive-graph",

    getDefaultProps: function getDefaultProps() {
        return {
            labels: ["x", "y"],
            range: [[-10, 10], [-10, 10]],
            step: [1, 1],
            valid: true,
            backgroundImage: defaultBackgroundImage,
            markings: "graph",
            showProtractor: false,
            showRuler: false,
            showTooltips: false,
            rulerLabel: "",
            rulerTicks: 10,
            correct: {
                type: "linear",
                coords: null
            }
        };
    },

    // TODO(jack): Use versioning instead of DeprecationMixin
    deprecatedProps: deprecatedProps,

    componentWillMount: function componentWillMount() {
        DeprecationMixin.componentWillMount.call(this);
    },


    render: function render() {
        var _this = this;

        var graph;
        var equationString;

        var gridStep = this.props.gridStep || Util.getGridStep(this.props.range, this.props.step, interactiveSizes.defaultBoxSize);
        var snapStep = this.props.snapStep || Util.snapStepFromGridStep(gridStep);

        var sizeClass = containerSizeClass.SMALL;
        if (this.props.valid === true) {
            // TODO(aria): send these down all at once
            var graphProps = {
                ref: "graph",
                box: this.props.box,
                range: this.props.range,
                labels: this.props.labels,
                step: this.props.step,
                gridStep: gridStep,
                snapStep: snapStep,
                graph: this.props.correct,
                backgroundImage: this.props.backgroundImage,
                markings: this.props.markings,
                showProtractor: this.props.showProtractor,
                showRuler: this.props.showRuler,
                rulerLabel: this.props.rulerLabel,
                rulerTicks: this.props.rulerTicks,
                trackInteraction: function trackInteraction() {},
                flexibleType: true,
                onChange: function onChange(newProps) {
                    var correct = _this.props.correct;
                    if (correct.type === newProps.graph.type) {
                        correct = _.extend({}, correct, newProps.graph);
                    } else {
                        // Clear options from previous graph
                        correct = newProps.graph;
                    }
                    _this.props.onChange({ correct: correct });
                }
            };
            graph = React.createElement(InteractiveGraph, _extends({}, graphProps, {
                containerSizeClass: sizeClass,
                apiOptions: _extends({}, this.props.apiOptions, {
                    isMobile: false
                })
            }));
            equationString = InteractiveGraph.getEquationString(graphProps);
        } else {
            graph = React.createElement(
                "div",
                { className: "perseus-error" },
                this.props.valid
            );
        }

        return React.createElement(
            "div",
            { className: "perseus-widget-interactive-graph" },
            React.createElement(
                "div",
                null,
                "Correct answer",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Graph the correct answer in the graph below and ensure the equation or point coordinates displayed represent the correct answer."
                    )
                ),
                " ",
                ": ",
                equationString
            ),
            React.createElement(GraphSettings, {
                box: getInteractiveBoxFromSizeClass(sizeClass),
                range: this.props.range,
                labels: this.props.labels,
                step: this.props.step,
                gridStep: gridStep,
                snapStep: snapStep,
                valid: this.props.valid,
                backgroundImage: this.props.backgroundImage,
                markings: this.props.markings,
                showProtractor: this.props.showProtractor,
                showRuler: this.props.showRuler,
                showTooltips: this.props.showTooltips,
                rulerLabel: this.props.rulerLabel,
                rulerTicks: this.props.rulerTicks,
                onChange: this.props.onChange
            }),
            this.props.correct.type === "polygon" && React.createElement(
                "div",
                { className: "type-settings" },
                React.createElement(
                    "label",
                    null,
                    " ",
                    "Student answer must",
                    " ",
                    React.createElement(
                        "select",
                        {
                            value: this.props.correct.match,
                            onChange: this.changeMatchType
                        },
                        React.createElement(
                            "option",
                            { value: "exact" },
                            "match exactly"
                        ),
                        React.createElement(
                            "option",
                            { value: "congruent" },
                            "be congruent"
                        ),
                        React.createElement(
                            "option",
                            { value: "approx" },
                            "be approximately congruent"
                        ),
                        React.createElement(
                            "option",
                            { value: "similar" },
                            "be similar"
                        )
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "ul",
                        null,
                        React.createElement(
                            "li",
                            null,
                            React.createElement(
                                "p",
                                null,
                                React.createElement(
                                    "b",
                                    null,
                                    "Match Exactly:"
                                ),
                                " Match exactly in size, orientation, and location on the grid even if it is not shown in the background."
                            )
                        ),
                        React.createElement(
                            "li",
                            null,
                            React.createElement(
                                "p",
                                null,
                                React.createElement(
                                    "b",
                                    null,
                                    "Be Congruent:"
                                ),
                                " Be congruent in size and shape, but can be located anywhere on the grid."
                            )
                        ),
                        React.createElement(
                            "li",
                            null,
                            React.createElement(
                                "p",
                                null,
                                React.createElement(
                                    "b",
                                    null,
                                    "Be Approximately Congruent:"
                                ),
                                " Be exactly similar, and congruent in size and shape to within 0.1 units, but can be located anywhere on the grid.",
                                " ",
                                React.createElement(
                                    "em",
                                    null,
                                    "Use this with snapping to angle measure."
                                )
                            )
                        ),
                        React.createElement(
                            "li",
                            null,
                            React.createElement(
                                "p",
                                null,
                                React.createElement(
                                    "b",
                                    null,
                                    "Be Similar:"
                                ),
                                " Be similar with matching interior angles, and side measures that are matching or a multiple of the correct side measures. The figure can be located anywhere on the grid."
                            )
                        )
                    )
                )
            ),
            this.props.correct.type === "angle" && React.createElement(
                "div",
                { className: "type-settings" },
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        " ",
                        "Student answer must",
                        " ",
                        React.createElement(
                            "select",
                            {
                                value: this.props.correct.match,
                                onChange: this.changeMatchType
                            },
                            React.createElement(
                                "option",
                                { value: "exact" },
                                "match exactly"
                            ),
                            React.createElement(
                                "option",
                                { value: "congruent" },
                                "be congruent"
                            )
                        )
                    ),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "Congruency requires only that the angle measures are the same. An exact match implies congruency, but also requires that the angles have the same orientation and that the vertices are in the same position."
                        )
                    )
                )
            ),
            graph
        );
    },

    changeMatchType: function changeMatchType(e) {
        var correct = _.extend({}, this.props.correct, {
            match: e.target.value
        });
        this.props.onChange({ correct: correct });
    },

    serialize: function serialize() {
        var json = _.pick(this.props, "step", "backgroundImage", "markings", "labels", "showProtractor", "showRuler", "showTooltips", "rulerLabel", "rulerTicks", "range", "gridStep", "snapStep");

        var graph = this.refs.graph;
        if (graph) {
            var correct = graph && graph.getUserInput();
            _.extend(json, {
                // TODO(alpert): Allow specifying flexibleType (whether the
                // graph type should be a choice or not)
                graph: { type: correct.type },
                correct: correct
            });

            _.each(["allowReflexAngles", "angleOffsetDeg", "numPoints", "numSides", "numSegments", "showAngles", "showSides", "snapTo", "snapDegrees"], function (key) {
                if (_.has(correct, key)) {
                    json.graph[key] = correct[key];
                }
            });
        }
        return json;
    }
});

module.exports = InteractiveGraphEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interactive-graph-editor.jsx
 ** module id = 119
 ** module chunks = 0 1
 **/